"use client";

import { ChevronDown } from "lucide-react";

interface SelectFilterProps {
  label: string;
  value: string;
  options: readonly string[];
  onChange: (v: string) => void;
}

/** 带前置标签的下拉筛选器（用量页 / 账单页共用） */
export function SelectFilter({ label, value, options, onChange }: SelectFilterProps) {
  return (
    <label className="relative inline-flex cursor-pointer items-center">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs text-[#7f8287]">
        {label}
      </span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 cursor-pointer appearance-none rounded-lg border border-[#e5e5e5] bg-white pl-16 pr-8 text-sm text-[#212327] transition-colors hover:border-[#b8bdc4] focus:border-[#4d6bfe] focus:outline-none focus:ring-2 focus:ring-[#4d6bfe]/20"
      >
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#7f8287]" />
    </label>
  );
}
